import React from "react";
import { MessageCircle, CalendarCheck, Video, Award } from "lucide-react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./HowItWorks.css";
const STEPS = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Enquire",
    text: "Tell us the course you're interested in through WhatsApp or a quick call. Our mentors will help you understand the syllabus, batch timings, and learning path.",
  },
  {
    n: "02",
    icon: CalendarCheck,
    title: "Choose Your Batch",
    text: "Pick a batch that suits your college schedule, work hours, or personal routine. Flexible morning, evening, and weekend options are available.",
  },
  {
    n: "03",
    icon: Video,
    title: "Join Live Mentor Sessions",
    text: "Attend interactive Google Meet classes where you can ask questions, collaborate with mentors, and learn alongside a small group of students.",
  },
  {
    n: "04",
    icon: Award,
    title: "Build Real Projects",
    text: "Complete hands-on assignments and portfolio-ready projects that demonstrate your practical skills beyond certifications.",
  },
];
export default function HowItWorks() {
  const revealRef = useScrollReveal();
  return (
    <section className="how" id="how-it-works" ref={revealRef}>
      <div className="container">
        <div className="section-head center reveal">
          <h2>Learn Online in Four Simple Steps</h2>
        </div>
        <div className="how__steps">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <div className={`how__step reveal reveal-delay-${i + 1}`} key={step.n}>
                <div className="how__step-top">
                  <span className="how__step-n">{step.n}</span>
                  <span className="how__step-icon">
                    <Icon size={20} />
                  </span>
                </div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
                {i < STEPS.length - 1 && <span className="how__connector" aria-hidden="true" />}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}